import { Link } from "react-router-dom";
import AnimationOnScroll from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import BackArrow from "../assets/images/back-arrow.svg";
import DentalSmile from "../assets/images/dental-smile.svg";
import CameraIcon from "../assets/images/camera-icon.svg";
import Privacy from "../assets/images/privacy.svg";
import Clock from "../assets/icons/clock.svg";

const DentalStart = () => {
  return (
    <section className="pt-2 flex flex-col">
      <div className="px-6 tab-screen">
        <div className="flex items-center mb-8 w-full relative z-50">
          <Link
            to={-1}
            className=" w-9 h-9 bg-[#2D2D2D] rounded-full flex flex-row justify-center items-center"
          >
            <img src={BackArrow} alt="" />
          </Link>
          <h2 className="text-xl lg:text-2xl md:text-2xl font-medium text-white ml-6">
            Dental <span className="text-secondary">Ai</span>
          </h2>
          <div></div>
        </div>
      </div>

      <div className="circle-blur w-[80%] lg:w-[60%] md:w-[60%] h-64 mx-auto mt-0 blur-[60px] absolute left-0 right-0"></div>

      <div className="px-6 w-full mx-auto relative z-50 tab-screen">
        <div className="bg-[#1D1D1D]/70 rounded-[20px] p-4 mb-7">
          <h2 className="text-lg lg:text-xl md:text-xl font-semibold text-secondary text-center mb-2 mt-2">
            Smart Oral Health Check
          </h2>

          <p className="text-[13px] font-light text-white text-center leading-5 mb-3">
            Get instant insights into your oral health with AI-powered dental
            analysis
          </p>

          <img src={DentalSmile} className="h-40 mx-auto" alt="" />

          <Link
            className="w-6/12 mx-auto rounded-full outline-none px-5 h-10 bg-white text-primary flex flex-row justify-center items-center mb-3 mt-3"
            to="/capture-type"
          >
            <img src={CameraIcon} alt="" className="mr-2" /> Scan My Teeth
          </Link>
        </div>
      </div>
      <div className="w-full bg-white px-6 pb-20 pt-3">
        <div className="tab-screen px-6">
          <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
            <div className="mt-4 flex flex-col space-y-1.5">
              <h3 className="text-lg lg:text-xl md:text-xl mb-4 font-semibold text-primary">
                Why Choose Careplix?
              </h3>
              <div className="flex flex-row pb-4">
                <span className="w-10 h-10 rounded-lg bg-secondary mr-4 flex items-center justify-center">
                  <img src={CameraIcon} className="w-5 h-5" alt="" />
                </span>
                <div className="w-10/12">
                  <h4 className="text-sm font-medium text-primary mb-1">
                    AI-Powered Analysis
                  </h4>
                  <p className="text-xs text-primary/85">
                    Advanced computer vision analyzes your dental health
                    instantly
                  </p>
                </div>
              </div>
              <div className="flex flex-row pb-4">
                <span className="w-10 h-10 rounded-lg bg-secondary mr-4 flex items-center justify-center">
                  <img src={Privacy} className="w-5 h-5" alt="" />
                </span>
                <div className="w-10/12">
                  <h4 className="text-sm font-medium text-primary mb-1">
                    Privacy First
                  </h4>
                  <p className="text-xs text-primary/85">
                    Your dental data is encrypted and stays secure on your
                    device
                  </p>
                </div>
              </div>
              <div className="flex flex-row pb-4">
                <span className="w-10 h-10 rounded-lg bg-secondary mr-4 flex items-center justify-center">
                  <img src={Clock} className="w-5 h-5" alt="" />
                </span>
                <div className="w-10/12">
                  <h4 className="text-sm font-medium text-primary mb-1">
                    Instant Results
                  </h4>
                  <p className="text-xs text-primary/85">
                    Get your personalized dental health report in seconds
                  </p>
                </div>
              </div>
            </div>
          </AnimationOnScroll>
        </div>
      </div>

      {/* <Link to={-1} className="block mt-4 text-sm font-medium  text-white">
      Back
    </Link> */}
    </section>
  );
};

export default DentalStart;
